import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Notice } from './patterns';

export function RbacV2Banner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (!user || dismissed) return null;
  if (user.superadmin) return null;
  if (!user.role?.isFarmAdministrator) return null;
  if (user.acknowledgedRbacV2) return null;

  const dismiss = async () => {
    try {
      await axios.post('/api/v1/users/me/acknowledgeRbacV2');
    } catch {
      // Even if the network call fails, dismiss locally so the user isn't blocked
    }
    setDismissed(true);
  };

  return (
    <div style={{ margin: '0.5rem 1rem' }}>
      <Notice tone="info" role="alert">
        <p style={{ marginBottom: '0.5rem' }}>
          Roles have been simplified. Your custom roles have been auto-migrated to the new model.
          Please review each role to confirm access is correct. Read/Write data permissions no longer
          exist — every granted menu now allows full access.
        </p>
        <div>
          <a href="/settings/tenant" style={{ marginRight: '1rem' }}>Review roles →</a>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={dismiss}>
            Dismiss
          </button>
        </div>
      </Notice>
    </div>
  );
}

export default RbacV2Banner;
